<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import type { ProductListItemResponse } from '@/typings/responses/ProductListItemResponse';

const { locale } = useI18n();
  
const props = defineProps<{
  product: ProductListItemResponse
}>();

function setFallbackImage(event: Event): void {
  const target = event.target as HTMLImageElement;
  target.src = '/assets/noimage.jpg';
}

</script>

<template>
  <div class="card">
	<a :href="product.url">
		<div class="card-image">
			<img :src="product.imageUrlSmall + '&quality=90'" :srcset="`${product.imageUrlSmall}&quality=90 622w, ${product.imageUrl}&quality=90 622w`" @error="setFallbackImage">
		</div>
		<div class="card-infos" v-if="!product.textAsTitle">
			<div v-if="product && product.title" class="card-title">{{ product.title }}</div>
			<div v-if="product && product.text" class="card-smallDesc">{{ product.text }}</div>
		</div>
		<div class="card-infos" v-else>
			<div v-if="product && product.title" class="card-title">{{ product.text }}</div>
		</div>
	</a>
</div>
</template>

<style lang="scss">

</style>
